import { useState } from "react";
import { useTranslation } from "react-i18next";

import { FriendsWithBenefitsRates } from "@/components/FriendsWithBenefits/FriendsWithBenefitsRates";
import { Button } from "@/components/Interface/Button/Button";
import { Modal } from "@/components/Interface/Modal/Modal";
import { FlatMobileDeviceToUpgradeSelection } from "@/components/Portal/Cockpit/Tiles/UpsellTile/FlatMobileDeviceToUpgradeSelection";
import { useGetCustomerTribe, useGetDetailTribe } from "@/services/api";

export const NoEligibleProductContent = () => {
  const { t } = useTranslation();

  const [showDeviceSelection, setShowDeviceSelection] = useState(false);
  const { data: customerTribe } = useGetCustomerTribe();
  const { data: tribeDetail } = useGetDetailTribe(customerTribe?.tribeId || "");

  return (
    <div>
      <FriendsWithBenefitsRates
        tribeDiscount={tribeDetail?.tribeDiscountNext || 0}
      >
        <Button
          fullWidth
          className="accent mb-16 mt-6"
          onClick={() => setShowDeviceSelection(true)}
        >
          {t("portal:friendsWithBenefits.groupOverview.orderFM")}
        </Button>
        {showDeviceSelection && (
          <Modal
            title={t("portal:friendsWithBenefits.groupOverview.titlePopUp")}
            onClose={() => setShowDeviceSelection(false)}
          >
            <FlatMobileDeviceToUpgradeSelection
              topSectionSubtitle={t(
                "portal:friendsWithBenefits.groupOverview.subtitlePopUp",
              )}
              description={t(
                "portal:friendsWithBenefits.groupOverview.descriptionPopUp",
              )}
              bottomSectionSubtitle={t(
                "portal:friendsWithBenefits.groupOverview.bottomSectionubtitlePopUp",
              )}
              bottomSectionCheckboxLabel={t(
                "portal:friendsWithBenefits.groupOverview.checkBoxLabelPopUp",
              )}
              redirectToSimSelection
            />
          </Modal>
        )}
      </FriendsWithBenefitsRates>
      <div className="mb-6 flex items-center gap-2">
        <hr className="w-8 rounded-sm border-1 border-secondary-100" />
        <h4 className="text-base text-primary-100">
          {t("portal:friendsWithBenefits.groupOverview.inviteFriends")}
        </h4>
      </div>
    </div>
  );
};
